<template>
    <div>
      <FormulaBanner :title="title" :formulaCode="formulaCode"/>
      <div class="index">
        <!-- 表单 -->
        <div>
          <div class="top_nav"><span></span>{{title}}
          </div>
          <div class="formBody">
            <!-- 表单 -->
            <MyPatient :memberId="memberId" :selectValue="selectValue" @change="userChange"/>
            <TemplateFiveList :type="'radio'" :list-data="listData" :selectValue="listSelect" @change="listChange"></TemplateFiveList>
            <div v-if="compute === true" style="margin: 16px;display: flex;justify-content: center;">
              <van-button class="formula-template-button" block type="info" @click="submit" style="width:90px">提交</van-button>
            </div>

            <!-- 计算结果 -->
            <!-- <div class="CalculationResultsBox" v-if="countText || countText !== ''"> -->
              <!-- <div class="CalculationResults"><span>计算结果</span></div> -->
              <!-- 具体标准 -->
              <!-- <div>
                <div class="CalculationDetail"><span></span>{{result}}分 {{countText}}</div>
              </div> -->
              <!--            <div>-->
              <!--              <div class="CalculationDetail"><span></span>具体标准：</div>-->
              <!--            </div>-->
            <!-- </div> -->
             <div style="display: flex;flex-direction: column;justify-content: center;">

             </div>
          </div>
        </div>
        <!-- <CalculationResults :countText="countValue" :countTextList="countTextList" v-if="show"></CalculationResults> -->
         <!-- 计算结果 -->
        <multipleResult v-if="show" :countText="countText" :countTextList="countResultARR"></multipleResult>
        <!-- 后台设置的值 -->
        <FormulaExplain :explain-data="tableData.explain"></FormulaExplain>
        <!-- 参考文献 -->
        <FormulaReferences :references-data="tableData.references"></FormulaReferences>
      </div>
  
      <van-popup v-model="showPicker" position="bottom">
        <van-picker
            title="应激指数"
            show-toolbar
            :columns="columns"
            @confirm="onConfirm"
            @cancel="onCancel"
        />
      </van-popup>
  
    </div>
  
  </template>
  
  <script>
  import MyPatient from '@/components/MyPatient.vue'
  import FormulaBanner from '@/components/FormulaBanner.vue'
  import {Toast} from "vant";
  import {getAdmins} from "@/utils/adminDate";
  import {setById} from "@/service/base";
  import {getFormula, getFormulaHuiXian, postFormula} from "@/service/BodyMassIndex_api";
  import FormulaExplain from "@/components/template1/FormulaExplain";
  import FormulaReferences from "@/components/template1/FormulaReferences";
  import TemplateFiveList from "@/components/Template5/TemplateFiveList";
  import multipleResult from "@/components/multipleResult";
  export default {
    name: "medicalSearch",
    data(){
      return{
        compute:true,
        countTextList:[],
        show:false,
        countValue:"",
        listSelect: [],
        countResultARR:[],
        listData: [
          {
            title: '核心体温(℃)',
            columns: ['39.1-40.0', '40.1-41.0', '41.1-42.0', '≥42.0'],
            fenzhi: [1,2,3,4] //分值顺序必须和选项顺序保持一致！！！！！！！！！！！！！！！
          },
          {
            title: '氧合指数(mmHg)',
            columns: ['>300(氧疗)','<300(机械通气)','<200(机械通气)','<100(机械通气)'],
            fenzhi: [1,2,3,4]  //分值顺序必须和选项顺序保持一致！！！！！！！！！！！！！！！
          },
          {
            title: '血小板计数（x10⁹/L)',
            columns: ['<140','<100','<50','<20'],
            fenzhi: [1,2,3,4]  //分值顺序必须和选项顺序保持一致！！！！！！！！！！！！！！！
          },
          {
            title: '胆红素(μmol/L)',
            columns: ['21-42','43-101','102-204','>204'],
            fenzhi: [1,2,3,4]  //分值顺序必须和选项顺序保持一致！！！！！！！！！！！！！！！
          },
          {
            title: '血压',
            columns: ['MAP<70 mmHg','多巴胺≤5 μg/(kg·min)或多巴酚丁胺(无论剂量）','去甲肾上腺素≤0.1μg/(kg·min)或肾上腺素≤0.1μg/(kg·min)或多巴胺>5 μg/(kg·min)','去甲肾上腺素>0.1μg/(kg·min)或肾上腺素>0.1μg/(kg·min)或多巴胺>15 μg/(kg·min)'],
            fenzhi: [1,2,3,4]  //分值顺序必须和选项顺序保持一致！！！！！！！！！！！！！！！
          },
          {
            title: '血乳酸(mmol/L)',
            columns: ['2.1-4.0','4.1-8.0','8.1-10.0','>10.0'],
            fenzhi: [1,2,3,4]  //分值顺序必须和选项顺序保持一致！！！！！！！！！！！！！！！
          },
          {
            title: 'GCS评分(分)',
            columns: ['10-14','7-9','5-6','<5'],
            fenzhi: [1,2,3,4]  //分值顺序必须和选项顺序保持一致！！！！！！！！！！！！！！！
          },
          {
            title: '肌酐(μmolL)或尿量(ml/d)',
            columns: ['肌酐100-160或尿量<800','肌酐161-250或尿量<400','肌酐251-400或尿量<100','肌酐>400或无尿'],
            fenzhi: [1,2,3,4]  //分值顺序必须和选项顺序保持一致！！！！！！！！！！！！！！！
          },

        ],
        formulaCode: '',
        shengao: '',
        yingjizhishu: '',
        title: '',
        memberId: '1111',
        selectValue: '',
        username:"",
        value:"",
        showPopover: false,
        showPicker: false,
        columns: ['', '', '',''],
        nianling: '',
        xingbie: null,
        tableData: {},
        countText: '',
        patientId: null,
        result: null,
        yingjizhishuzhi: '',
        tizhong: '',
        xueqingnanongdu: '',
        fenzhiList: [],
      }
    },
    components: {
      FormulaBanner,
      MyPatient,
      FormulaExplain,
      FormulaReferences,
      TemplateFiveList,
      multipleResult
    },
    async created() {
      await this.test()
      await this.getTableData()
    },
  
    methods:{
      listChange (result, fenzhi) {
        this.show=false
        this.listSelect = result //结果数组
        this.fenzhiList = fenzhi  //分值数组
     
      },
      coumputTetxt () {
        this.show=true
        let fenshu = 0
        for (let i = 0; i < this.fenzhiList.length; i++) {
          fenshu += this.fenzhiList[i]
        }

        this.result = fenshu
        if(fenshu  <= 10 && fenshu  >= 1){  
          this.countResultARR = 
          [
            {name:'总分',result:fenshu,unit:'分'},
            {name:'危重程度',result:'轻度'}
          ]
          this.countText = `${fenshu}分 危重程度：轻度`
        }else if(fenshu  >= 11 && fenshu  <= 20){
          this.countResultARR = 
          [
            {name:'总分',result:fenshu,unit:'分'},
            {name:'危重程度',result:'中度'}
          ]
          this.countText =  `${fenshu}分 危重程度：中度`
        }else if(fenshu  > 20){
          this.countResultARR = 
          [
            {name:'总分',result:fenshu,unit:'分'},
            {name:'危重程度',result:'重度'}
          ]
          this.countText =  `${fenshu}分 危重程度：重度`
        }
      },
      async test(){
        //像接口头部传用户信息
        let arrays = await getAdmins(this.$route.query.memberId,this.$route.query.channel)
        this.channel = arrays.os
        this.version = arrays.version
        this.ip = arrays.ip
        await setById(arrays)
      },
      async getTableData () {
        const data = {
          channel: this.$router.currentRoute.query.channel,
          code: 'HGKHXQDF',
        }
        const res = await getFormula(data.channel, data.code)
        if (res.code === 0) {
          this.tableData = res.data
          this.formulaCode = res.data.code
          this.title = res.data.chineseName
        }
        if (this.$router.currentRoute.query.location === 'YXGS_RECORD_LIST' && this.$router.currentRoute.query.logId) {
          // this.compute = false
          const data = {
            id: this.$router.currentRoute.query.logId
          }
          const res = await getFormulaHuiXian(data)
          if (res.code === 0) {
            this.listSelect = res.data.content.data
            if (res.data.patientId) this.selectValue = {id: res.data.patientId, name: res.data.patientName}
            this.fenzhiList = [res.data.result.value]
            this.countResultARR = res.data.result.value
            // this.countValue= res.data.result.result
            this.countText = res.data.result.DisplayResults.replace(/'/g, '`')
            this.show=true
            // console.log("数据",res.data)
          }
        }
      },
      async submit () {
        // console.log("??",this.listSelect,this.listData.length)
        // if (this.listSelect.length!==this.listData.length) {
        //   Toast.fail('请完善选择')
        //   return
        // }
        this.coumputTetxt()
        const data = {
          id: this.$router.currentRoute.query.location === 'YXGS_RECORD_LIST' ? this.$router.currentRoute.query.logId : null,
          patientId: this.patientId,
        //   columnCode: this.tableData.columnCode,
          columnCode: 0,
          formulaCode: this.tableData.code,
          channel: this.$router.currentRoute.query.channel,
          location: this.$router.currentRoute.query.location,
          content: {
            data: this.listSelect
            // xueqingnanongdu: {value: this.xueqingnanongdu, unit: 'mmol/L'},
          },
          result: {
            value: this.countResultARR,
            // result: this.countValue,
            DisplayResults:this.countText  //纯字符串
          }
        }
        const res = await postFormula(data)
        if (res.code === 0) {
          Toast.success('提交成功')
        } else {
          Toast.fail(res.message)
        }
      },
      calculateAge(birthDateString) {
        const today = new Date();
        const birthDate = new Date(birthDateString);
        let age = today.getFullYear() - birthDate.getFullYear();
        // 如果今天的日期还没到生日月份和日期，则年龄减一
        if (today.getMonth() < birthDate.getMonth() ||
            (today.getMonth() === birthDate.getMonth() && today.getDate() < birthDate.getDate())) {
          age--;
        }
        return age;
      },
      // 开参考文献链接
      openLink(u){
        if (!u) {
          return
        }
        //获取系统版本
        let userAI = navigator.userAgent;
        const isAndroid = userAI.indexOf('Android') > -1 || userAI.indexOf('Linux') > -1; //Android终端
        const isIOS = !!userAI.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); // ios终端
        if (isAndroid) {
          // alert('安卓操作系统')
          // 这个是安卓操作系统
          window.open(u)
        }
        if (isIOS) {
          // 这个是ios操作系统
          // alert('ios操作系统')
          window.location.href = u
        }
      },
      yingjiClick () {
        this.showPicker = true
      },
      onConfirm(value) {
        this.yingjizhishu = value
        this.showPicker = false
      },
      onCancel() {
        this.showPicker = false
      },
      userChange (data) {
        if (data.birthday && data.birthday !== '') {
          this.nianling = this.calculateAge(data.birthday)
        } else {
          this.nianling = ''
        }
        this.xingbie = data.sex
        this.patientId = data.id
        this.selectValue = data
      },
    }
  }
  </script>
  
  
  <style scoped lang="scss">
  .index{
    background: #F6F6F6;
    padding: 10px 15px;
    min-height: 100vh;
    .StandardDescription{
      margin-top:10px;
      .top_nav{
        font-size: 16px;
        color: #333333;
        font-weight: bold;
        display: flex;
        align-items: center;
        justify-content: start;
        margin-bottom:10px;
        span {
          display: inline-block;
          width: 5px;
          height: 15px;
          background: #259beb;
          margin-right: 5px;
        }
      }
      .StandardDeatil{
        width:100%;
        padding:15px 10px;
        //   height: 50px;
        background-color: #fff;
        box-sizing: border-box;
      }
    }
    .top_nav{
      font-size: 16px;
      color: #333333;
      font-weight: bold;
      display: flex;
      align-items: center;
      justify-content: start;
      margin-bottom:10px;
      span {
        display: inline-block;
        width: 5px;
        height: 15px;
        background: #259beb;
        margin-right: 5px;
      }
    }
    .formBody{
      background-color: #fff;
      padding-bottom:10px;
      .CalculationResultsBox{
        padding:0 8px;
        .CalculationResults{
          font-size: 16px;
          color: #333333;
          font-weight: bold;
          display: flex;
          justify-content: center;
          margin-bottom:10px
        }
        .CalculationDetail{
          font-size: 15px;
          color: #333333;
          // font-weight: bold;
          display: flex;
          align-items: center;
          justify-content: start;
          margin-bottom:10px;
          background-color: #f6f6f6;
          // height: 16px;
          span{
            display: inline-block;
            width: 3px;
            height: 24px;
            background: #fe9712;
            margin-right: 5px;
          }
        }
      }
    }
    .titles{
      display:flex;
      align-items: center;
      justify-content: space-between;
      width:100%;
      height: 50px;
      border-bottom: 1px solid #f0f0f0;
      padding: 0 10px;
      box-sizing: border-box;
      .titlesName{
        font-size:16px;
        i{
          color: red;
        }
      }
      .information{
        font-size:16px;
        margin-right:4px;
        .PleaseSelect{
          color: #b9b9b9;
        }
        .vanCell{
          width:50px;
          padding:0;
          height: 100%;
        }
      }
      .vBotton{
        width:60px
      }
      .unit{
        height: 50px;
        //   line-height: 50px;
        display: flex;
        align-items: center;
        font-size:16px;
        width:20px;
      }
      .vanIcon{
        font-size:13px;
        color:#a8a8a8;
        font-weight: 650;
      }
    }
  }
  ::v-deep .van-cell {
    padding:0px 0px;
  }
  ::v-deep .van-field__control{
    height: 50px;
    font-size: 16px;
  }
  ::v-deep .van-field__error-message {
    position: absolute;
    top: 30px;
    left: 10px;
  }
  .StandardDeatil2{
    width:100%;
    padding: 15px 10px;
    padding-bottom:1px;
    //   height: 50px;
    background-color: #fff;
    box-sizing: border-box;
    .references{
      margin-bottom:15px
    }
  }
  ::v-deep p {
    padding: 0;
    margin: 0;
  }
  .Abutton {
  
  }
  </style>
  